import List from 'containers/Platforms/List';
import Edit from 'containers/Platforms/Edit';
import Create from 'containers/Platforms/Create';
import Show from 'containers/Platforms/Show';

export default { List, Edit, Create, Show };
